import { Component, Prop } from "vue-property-decorator";
import { confirmDeletion } from "@/helper/global-helper";
import { GuardileoEditComponent } from "@/lib/GuardileoEditComponent";
import {
  DrittlandtransferpruefungApi,
  Drittlandtransferpruefung_Angaben_info,
  Drittlandtransferpruefung_Dokumentationsangaben,
} from "./api-dltp";
import { Auswahlliste, Auswahl as APIAuswahl } from "@/api";
import { Auswahl as UIAuswahl } from "@/components/Auswahlliste";

@Component({})
export class DrittlandtransferpruefungTabBase extends GuardileoEditComponent {
  protected api: DrittlandtransferpruefungApi = new DrittlandtransferpruefungApi();

  @Prop() private dltp_id?: number;

  private status_geprueft: boolean = false;

  protected id: number = 0;

  private orig_data: Drittlandtransferpruefung_Angaben_info | null = null;
  protected data: Drittlandtransferpruefung_Angaben_info | null = null;
  protected auswahllisten: Record<string, Auswahlliste> = {};
  protected auswahl: Record<string, UIAuswahl> = {};

  async mounted() {
    this.$el.addEventListener("guardileo-form-forceupdate", (e) => {
      e.stopPropagation();
      this.cut_golden_thread();
    });
  }

  loaded() {
    // override me
  }

  async load() {
    this.id = this.dltp_id ? this.dltp_id : (<any>this.$route.params).id;
    this.data = await this.guard_status(async () => await this.api.Angaben(this.id));
    this.on_data();
  }

  on_data() {
    this.orig_data = JSON.parse(JSON.stringify(this.data));
    if (!this.data) return;
    this.auswahl = {};
    for (const auswahl of this.data.Angaben.Eintraege) {
      this.auswahl[auswahl.ElementId] = { ...auswahl };
    }
    for (const liste of this.data.Auswahllisten) {
      this.auswahllisten[liste.ListenId] = liste;
    }
    this.status_geprueft = !!(this.data && this.data.Status == 3);
    this.loaded();
  }

  get Angaben(): Drittlandtransferpruefung_Dokumentationsangaben {
    this.use_golden_thread();

    if (!this.data) throw new Error("data is null or undefined.");

    const Eintraege: APIAuswahl[] = Object.keys(this.auswahl)
      .map((ElementId) => ({
        ListeId: this.auswahl[ElementId].ListeId,
        ElementId,
        Freitext: this.auswahl[ElementId].Freitext,
      }))
      .sort((a: APIAuswahl, b: APIAuswahl): number => (a.ElementId < b.ElementId ? -1 : +1));

    return {
      ...this.data.Angaben,
      Eintraege,
    };
  }

  get darf_bearbeiten(): boolean {
    return (
      this.ready &&
      !this.readonly &&
      this.hat_Berechtigung("Verarbeitungstaetigkeiten_bearbeiten") &&
      !this.status_geprueft
    );
  }

  get darf_status_bearbeiten(): boolean {
    return this.ready && !this.readonly && this.hat_Berechtigung("Status_Verarbeitungstaetigkeit_setzen");
  }

  get kann_loeschen(): boolean {
    return !this.readonly && this.hat_Berechtigung("Verarbeitungstaetigkeiten_loeschen");
  }

  get darf_loeschen(): boolean {
    return !this.readonly && this.kann_loeschen && this.darf_bearbeiten;
  }

  async deleteItem() {
    confirmDeletion(
      this.$t("Drittlandtransferpruefung.loeschen1"),
      this.$t("Drittlandtransferpruefung.loeschen2"),
      this.$t("Drittlandtransferpruefung.loeschen3"),
      this.$t("Abbrechen"),
      async () => {
        await this.guard_save(() => this.api.Drittlandtransferpruefung_loeschen(this.id));
        this.$router.push({ name: "dienstleister" });
        this.$router.push({ name: "drittlandtransferpruefung" });
      },
      () => {}
    );
  }

  get isDirty(): boolean {
    if (this.readonly) return false;
    this.use_golden_thread();

    if (!this.orig_data) return false;

    // console.log(JSON.stringify(this.orig_data.Angaben));
    // console.log(JSON.stringify(this.Angaben));
    return JSON.stringify(this.orig_data.Angaben) != JSON.stringify(this.Angaben);
  }

  get valid(): boolean {
    return true;
  }
}
